import Login from 'components/Login';
import RegisterPassword from 'components/RegisterPassword';
import ResetPassword from 'components/ResetPassword';
import Dashboard from 'components/Dashboard';
import DashboardCreative from 'components/Dashboard/Creative/List';
import DashboardCreativeForm from 'components/Dashboard/Creative/Form';
import DashboardAnalista from 'components/Dashboard/Analista';
import DashboardManager from 'components/Dashboard/Manager';
import DashboardDiretor from 'components/Dashboard/Diretor';

import SelectArea from 'components/SelectArea';

import UsersList from 'components/Users/List';
import UsersForm from 'components/Users/Form';

import ProfilesList from 'components/Profiles/List';
import ProfilesForm from 'components/Profiles/Form';

import FundsList from 'components/Funds/List';
import FundsForm from 'components/Funds/Form';

import Statement from 'components/Statement';
import StatementList from 'components/Statement/List';

import CompaniesList from 'components/Companies/List';
import CompaniesForm from 'components/Companies/Form';

import CompanyRulesList from 'components/CompanyRules/List';
import CompanyRulesForm from 'components/CompanyRules/Form';

import ActionsList from 'components/Actions/List';
import ActionsForm from 'components/Actions/Form';

import EventsList from 'components/Events/List';
import EventsForm from 'components/Events/Form';

import MarketingPlanForm from 'components/MarketingPlan/Form';
import MarketingPlanLandingApproval from 'components/MarketingPlan/LandingApproval';
import MarketingPlanList from 'components/MarketingPlan/List';

import GeneralReport from 'components/Reports/GeneralReport';
import ReportVendor from 'components/Reports/ReportVendor';
import ReportVendorContact from 'components/Reports/ReportVendorContact';
import ActionsAwaitingPayment from 'components/Reports/ActionsAwaitingPayment';
import MarginMarketingPlan from 'components/Reports/MarginMarketingPlan';
import MarginVendor from 'components/Reports/MarginVendor';
import UsersWithPerfil from 'components/Reports/UsersWithPerfil';
import CompanyWithUsers from 'components/Reports/CompanyWithUsers';
import Reports from 'components/Reports';
import S3Explorer from 'components/S3Explorer';
import InvoiceForm from 'components/S3Explorer/Form';
import InvoiceApprovalListing from 'components/ListingInvoiceApproval';
import Advances from 'components/ListingAdvances'
import Invoices from 'components/Reports/Invoices'
import ReportFunds from 'components/Reports/Funds'
import ReportActions from 'components/Reports/Actions'

import ReportEvents from 'components/Reports/Events';

import Account from 'components/Account';

import Financial from 'components/Financial';
import InvoiceEdit from 'components/S3Explorer/Form/Edit';

import CreditCardForm from 'components/CreditCard/Form/Form';
import CreditCard from './CreditCard';

import Guide from './Guide'
import FundsByCompany from './Reports/FundsByCompany';
import RulesByManufacturer from './Reports/RulesByManufacturer';

const PublicRoutes = [
  { pathname: '/login', component: Login, exact: true },
  {
    pathname: '/RegisterPassword/:token/:id',
    component: RegisterPassword,
    exact: true,
  },
  {
    pathname: '/ResetPassword/:token/:email',
    component: ResetPassword,
    exact: true,
  },
];

const PrivateRoutes = [
  { pathname: '/', component: Dashboard, exact: true },
  { pathname: '/creative/show/:id', component: DashboardCreativeForm, exact: true, permission: "viewMediaCreation" },

  { pathname: '/creative', component: Dashboard, exact: true, permission: "viewMediaCreation" },
  { pathname: '/analyst', component: Dashboard, exact: true, permission: "viewAnalyst" },
  { pathname: '/director', component: Dashboard, exact: true, permission: "viewDirector" },
  //{ pathname: '/manager', component: DashboardManager, exact: true, permission: "viewManager" },

  { pathname: '/select-area', component: SelectArea, exact: true },
  {
    pathname: '/users',
    component: UsersList,
    exact: true,
    permission: 'listUsers',
  },
  {
    pathname: '/users/trash',
    component: UsersList,
    exact: true,
    props: { trash: true },
    permission: 'listUsers',
  },
  {
    pathname: '/users/create',
    component: UsersForm,
    exact: true,
    permission: 'createUser',
  },
  {
    pathname: '/users/edit/:id',
    component: UsersForm,
    exact: true,
    permission: 'editUser',
  },

  {
    pathname: '/profiles',
    component: ProfilesList,
    exact: true,
    permission: 'listProfiles',
  },
  {
    pathname: '/profiles/trash',
    component: ProfilesList,
    exact: true,
    props: { trash: true },
    permission: 'listProfiles',
  },
  {
    pathname: '/profiles/create',
    component: ProfilesForm,
    exact: true,
    permission: 'createProfile',
  },
  {
    pathname: '/profiles/edit/:id',
    component: ProfilesForm,
    exact: true,
    permission: 'editProfile',
  },

  { pathname: '/funds', component: FundsList, exact: true, permission: "listFunds" },
  {
    pathname: '/funds/trash',
    component: FundsList,
    exact: true,
    props: { trash: true },
    permission: "listFunds"
  },
  { pathname: '/funds/create', component: FundsForm, exact: true, permission: "createFund" },
  { pathname: '/funds/edit/:id', component: FundsForm, exact: true, permission: "editFund" },

  { pathname: '/statement', component: Statement, exact: true, permission: "listStatements" },
  { pathname: '/statement/:id', component: StatementList, exact: true, permission: "viewStatement" },

  {
    pathname: '/companies',
    component: CompaniesList,
    exact: true,
    permission: 'listCompanies',
  },
  {
    pathname: '/companies/trash',
    component: CompaniesList,
    exact: true,
    props: { trash: true },
    permission: 'listCompanies',
  },
  {
    pathname: '/companies/create',
    component: CompaniesForm,
    exact: true,
    permission: 'createCompany',
  },
  {
    pathname: '/companies/edit/:id',
    component: CompaniesForm,
    exact: true,
    permission: 'editCompany',
  },

  { pathname: '/company-rules', component: CompanyRulesList, exact: true, permission: "listCompanyRules" },
  {
    pathname: '/company-rules/create',
    component: CompanyRulesForm,
    exact: true,
    permission: 'createCompanyRules'
  },
  {
    pathname: '/company-rules/edit/:id/:year',
    component: CompanyRulesForm,
    exact: true,
    permission: 'editCompanyRules'
  },

  { pathname: '/actions', component: ActionsList, exact: true, permission: "listActions" },
  { pathname: '/actions/create', component: ActionsForm, exact: true, permission: "createAction" },
  { pathname: '/actions/edit/:id', component: ActionsForm, exact: true, permission: "editAction" },

  { pathname: '/events', component: EventsList, exact: true, permission: "listEvents" },
  { pathname: '/events/trash', component: EventsList, props:{trash: true, type: 'trash'}, exact: true, permission: "listEvents" },
  { pathname: '/events/finished', component: EventsList, props:{finished: true, type: 'finished'}, exact: true, permission: "listEvents" },
  { pathname: '/events/create', component: EventsForm, exact: true, permission: "createEvent" },
  { pathname: '/events/edit/:id', component: EventsForm, exact: true, permission: "editEvent" },

  { pathname: '/marketing-plans', component: MarketingPlanList, exact: true, permission: "listPlans" },
  {
    pathname: '/marketing-plans/create',
    component: MarketingPlanForm,
    exact: true,
    permission: "createPlan"
  },
  {
    pathname: '/marketing-plans/edit/:id',
    component: MarketingPlanForm,
    exact: true,
    permission: "editPlan"
  },

  { pathname: '/reports/general', component: GeneralReport, exact: true, permission: "viewGeneralReport" },
  { pathname: '/reports/vendors', component: ReportVendor, exact: true, permission: "viewVendorsReport" },
  {
    pathname: '/reports/report-vendor-contact',
    component: ReportVendorContact,
    exact: true,
    permission: "viewContactsReport"
  },
  {
    pathname: '/reports/actions-awaiting-payment',
    component: ActionsAwaitingPayment,
    exact: true,
    permission: "viewActionAwaitingPaymentReport"
  },
  {
    pathname: '/reports/margin-marketing-plan',
    component: MarginMarketingPlan,
    exact: true,
    permission: "viewMarginMarketingPlanReport"
  },
  {
    pathname: '/reports/margin-vendor',
    component: MarginVendor,
    exact: true,
    permission: "viewMarginVendorReport"
  },
  {
    pathname: '/reports/users',
    component: UsersWithPerfil,
    exact: true,
    permission: "viewUsersWithProfilesReport"
  },

  {
    pathname: '/reports/company',
    component: CompanyWithUsers,
    exact: true,
    permission: "viewVendorsWithUsersReport"
  },
  {
    pathname: '/reports/events',
    component: ReportEvents,
    exact: true,
    permission: "viewEventsReport"
  },
  {
    pathname: '/reports/invoices',
    component: Invoices,
    exact: true
  },
  {
    pathname: '/reports/funds-by-company',
    component: FundsByCompany,
    exact: true,
    permissions:"viewFundsByCompany"
  },
  {
    pathname: '/reports/funds',
    component: ReportFunds,
    exact: true,
    permission: "viewContactsReport"
  },
  {
    pathname: '/reports/rules-by-manufacturer',
    component: RulesByManufacturer,
    exact: true,
    permission: "viewRulesByManufacturer"
  },
  {
    pathname: '/reports/actions',
    component: ReportActions,
    exact: true,
  },

  { pathname: '/reports', component: Reports, exact: true, permission: "listReports" },
  { pathname: '/files', component: S3Explorer, exact: true, permission: "listExpenseDescriptions" },
  { pathname: '/files/add-invoice', component: InvoiceForm, exact: true, permission: "createExpenseDescription" },
  { pathname: '/files/add-invoice/advance-children/:parent_id', component: InvoiceForm, exact: true, permission: "createExpenseDescription" },
  { pathname: '/files/edit/:id', component: InvoiceEdit, exact: true, permission: "createExpenseDescription" },
  {
    pathname: '/files/approve-invoice',
    component: InvoiceApprovalListing,
    exact: true,
    permission:'approveExpenseDescription'
  },
  { pathname: '/files/:year(\\d+)', component: S3Explorer, exact: true, permission: "viewExpenseDescription" },
  { pathname: '/files/:year(\\d+)/:month', component: S3Explorer, exact: true, permission: "viewExpenseDescription" },
  { pathname: '/files/advance', component: Advances, exact: true, permission: "viewAdvances"},
  {
    pathname: '/marketing-plans/landing-approval/:hash',
    component: MarketingPlanLandingApproval,
    exact: true,
  },
  {
    pathname: '/account',
    component: Account,
    exact: true
  },
  {
    pathname: '/financial',
    component: Financial,
    exact: true
  },
  {
    pathname: '/creditcard',
    component: CreditCard,
    exact: true
  },
  {
    pathname: '/creditcard/form',
    component: CreditCardForm,
    exact: true
  },
  {
    pathname: '/creditcard/form/:id',
    component: CreditCardForm,
    exact: true
  },
  {
    pathname: '/guide',
    component: Guide,
    exact: true
  }
];

export { PublicRoutes, PrivateRoutes };
